import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DashboardHeader from '../../Header/DashboardHeader';
import DashboardFooter from '../../Footer/DashboardFooter';
import payment from '../../Dashboard/assets/img/payment-page.png';
import DashboardLeftMenu from '../../Dashboard/DashboardLeftMenu';
import { userProfile } from '../api/Api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet } from '@fortawesome/free-solid-svg-icons'
import Paypal from '../payment/Paypal'
import { HOST_URL } from '../api/Api';
import Axios from '../../../axios/Axios';
import { handleUserLog } from '../../Utils/Utils';
class TransactionPayment extends Component {

    constructor() {

        const lStorage = JSON.parse(localStorage.getItem("login"));
        const userId = lStorage?.user?.userId;
        const country_currency = lStorage.user.country_currency;
        const userToken = lStorage?.token;
        const resellerId = lStorage?.user?.reseller_id;
        // const storedMinRecharge = Number(localStorage.getItem("minRechargeAmount")) || 1000;
        // If not found, set default based on currency (INR → 1000, others → 10)
        // const storedMinRecharge =
        //     Number(localStorage.getItem("minRechargeAmount")) ||
        //     (country_currency === "INR" ? 1000 : 10);

const storedMinRecharge = country_currency === "INR" ? 1000 : 10;


        super();
        this.state = {
            user_id: userId,
            token: userToken,
            parent_id: resellerId,
            amount: '',
            baseAmount: '',
            storedMinRecharge,
            originalAmount: '',
            UserCountryCurrency: country_currency,
            convenienceFee: 0,
            // transactionFee: 0,
            // totalPaidAmount: 0,
            successMessage: false,
            errorMessage: '',
            IndiaUser: true,
            ProfileError: false,
            showPayPal: true,
            stripeRedirectUrl: '',
            isStripeProcessing: false,
            bgColor: "alert alert-danger alert-dismissible"
        }
    }



    // componentDidMount() {

    //     if (this.state.UserCountryCurrency === 'INR') {
    //         this.setState({ IndiaUser: true });
    //     } else {
    //         this.setState({ IndiaUser: false });
    //     }
    // }

    componentDidMount() {

    if (this.state.UserCountryCurrency === "INR") {
        this.setState({ IndiaUser: true });
    } else {
        this.setState({ IndiaUser: false });
    }

    userProfile({
        user_id: this.state.user_id,
        token: this.state.token,
        method: "retrieve"
    })
    .then((result) => {
        if (result.data.success === true) {

            const userData = result.data.data[0];

            let minAmount = this.state.UserCountryCurrency === "INR" ? 1000 : 10;

            if (userData.extra_param) {
                try {
                    const extra = JSON.parse(userData.extra_param);

                    if (
                        extra.min_recharge_amount &&
                        !isNaN(extra.min_recharge_amount) &&
                        Number(extra.min_recharge_amount) > 0
                    ) {
                        minAmount = Number(extra.min_recharge_amount);
                    }
                } catch (err) {
                    console.error("error:", err);
                }
            }

            this.setState({ storedMinRecharge: minAmount });
        }
    })
    .catch((err) => {
        console.error("API Error:", err);
    });
}


    MakePaymentStripe = () => {
        document.querySelector("body").scrollTo(0, 0);

        this.setState({ isStripeProcessing: true });

        let paramData = {
                user_id: this.state.user_id,
                method: "recharge",
                token: this.state.token,
                base_amount: this.state.originalAmount, // use same as input
                amount: this.state.originalAmount,
                currency: this.state.UserCountryCurrency,
            }

        Axios
            .post(`${HOST_URL}/payment_gateway_stripe.php`, paramData)
            .then((response) => {
                const result = response.data;

                if (result.success === true) {
                    handleUserLog("", "recharge_stripe_button", "transaction_payment", "Redirected to Stripe", "transaction_payment", "", paramData)
                    window.location = result.message; // redirect to Stripe
                    this.setState({isStripeProcessing: false})
                } else if (result.message === "IncompleteProfile") {
                    this.setState({
                        ProfileError: true,
                        isStripeProcessing: false,
                        bgColor: "alert alert-danger alert-dismissible",
                    });
                    handleUserLog("", "recharge_stripe_button", "transaction_payment", "IncompleteProfile", "transaction_payment", "", paramData)
                } else {
                    this.setState({
                        successMessage: true,
                        errorMessage: result.message,
                        isStripeProcessing: false,
                        bgColor: "alert alert-danger alert-dismissible",
                    });
                    handleUserLog("", "recharge_stripe_button", "transaction_payment", result.message, "transaction_payment", "", paramData)
                }
            })
            .catch((error) => {
                console.error("Error during Stripe payment process:", error);
                this.setState({
                    successMessage: true,
                    errorMessage: "Something went wrong while processing the payment.",
                    isStripeProcessing: false,
                    bgColor: "alert alert-danger alert-dismissible",
                });
                handleUserLog("", "recharge_stripe_button", "transaction_payment", "Something went wrong while processing the payment.", "transaction_payment", "", paramData)
            });
    };


    MakePayment() {
        document.querySelector("body").scrollTo(0, 0);

        let paramData = {
                user_id: this.state.user_id,
                method: "recharge",
                token: this.state.token,
                base_amount: this.state.baseAmount.toFixed(2),
                amount: this.state.amount,
                parent_id: this.state.parent_id,

            }

        Axios
            .post(`${HOST_URL}/payment_gateway_razorpay.php`, paramData)
            .then((response) => {
                const result = response.data;

                if (result.success === true) {
                    handleUserLog("", "offline_payment", "transaction_payment", result.message || "Redirected to Payment Page", "transaction_payment", "", paramData)
                    window.location = result.message;
                } else if (result.message === "IncompleteProfile") {
                    this.setState({
                        ProfileError: true,
                        bgColor: "alert alert-danger alert-dismissible",
                    });
                    handleUserLog("", "offline_payment", "transaction_payment", "IncompleteProfile", "transaction_payment", "", paramData)
                } else {
                    this.setState({
                        successMessage: true,
                        errorMessage: result.message,
                        bgColor: "alert alert-danger alert-dismissible",
                    });
                    handleUserLog("", "offline_payment", "transaction_payment", result.message, "transaction_payment", "", paramData)
                }
            })
            .catch((error) => {
                console.error("Error during payment process:", error);
                this.setState({
                    successMessage: true,
                    errorMessage: "Something went wrong while processing the payment.",
                    bgColor: "alert alert-danger alert-dismissible",
                });
                handleUserLog("", "offline_payment", "transaction_payment", "Something went wrong while processing the payment.", "transaction_payment", "", paramData)
            });
    }


    render() {

        return (
            <div className="wrapper">
                <DashboardLeftMenu />
                <div className="main">
                    <DashboardHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className="row mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3><strong> Account </strong> Recharge </h3>
                                </div>
                            </div>

                            <div className="row">
                                <div className="card">
                                    <div className="">
                                        <h5 className="card-title mt-4">
                                            <div className="col-auto ml-auto text-right mt-n1">
                                                <nav className="text-center" aria-label="breadcrumb">
                                                    <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                                                        <Link to="transaction-payment" onClick={() => handleUserLog("", "recharge_tab", "transaction_payment", "User Click on Recharge tab", "transaction_payment", "", "")}> <li className="breadcrumb-item active "> Recharge </li> </Link>
                                                        <Link to="transaction-history" onClick={() => handleUserLog("", "transaction_history_tab", "transaction_payment", "User Click on Transaction History tab", "transaction_payment", "", "")}><li className="breadcrumb-item ">Transaction History </li> </Link>

                                                    </ol>
                                                </nav>
                                            </div>
                                        </h5>
                                    </div>

                                    <div className="card-body">

                                        {
                                            this.state.successMessage ?
                                                <div className={this.state.bgColor} role="alert">
                                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                    <div className="">
                                                        {this.state.errorMessage}
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }

                                        {
                                            this.state.ProfileError ?
                                                <div className="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span>
                                                    </button><div className="">You need to complete your profile before doing , First Payment <a href="/dashboard/my-profile">Profile Setting </a></div></div>
                                                : null
                                        }


                                        {this.state.IndiaUser ?


                                            <div className="filter-option mt-2 ">

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <h6 className="card-subtitle text-muted">Recharge </h6>
                                                        <div className="input-group mt-1">
                                                            <div className="input-group-text"><FontAwesomeIcon icon={faWallet} /></div>
                                                            <input type="number" onChange={(event) => {
                                                                var sum = parseFloat(event.target.value);
                                                                var convFee = parseFloat(sum * 0.18);
                                                                var tc = sum + convFee;
                                                                // var txnFee = parseFloat(tc * 0.03);
                                                                // var totalPayable = tc + txnFee;
                                                                this.setState({ amount: tc, convenienceFee: convFee, baseAmount: sum });

                                                            }
                                                            }
                                                                // placeholder={`Minimum recharge amount should be ₹${this.state.storedMinRecharge}`}
                                                                placeholder="Please enter the recharge amount"
                                                                className="form-control" />
                                                        </div>

                                                    </div>
                                                    <div className="col-md-1 border-right"></div>
                                                    <div className="col-md-1 "></div>
                                                    <div className="col-md-4 text-md-left">

                                                        Recharge Amount : <strong className="">
                                                            {
                                                                this.state.baseAmount
                                                            }
                                                        </strong> INR
                                                        <div className="card-subtitle text-muted mt-2"> <small> </small>GST Charges : {this.state.convenienceFee.toFixed(2)} INR

                                                        </div>
                                                        <div className="card-subtitle mt-2">
                                                            <strong>Total Paid Amount:</strong> <strong>{this.state.amount}</strong> INR
                                                        </div>
                                                        <p className="mt-1 mb-1 text-muted">
                                                            <small>Payment gateway charges will be added in the next step. *</small>
                                                        </p>
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <button
                                                                // onClick={() => this.MakePayment()} 
                                                                onClick={() => {
                                                                    if (this.state.baseAmount >= this.state.storedMinRecharge) {
                                                                        this.MakePayment();
                                                                    } else {
                                                                        this.setState({
                                                                            successMessage: true,
                                                                            errorMessage: `Minimum recharge amount should be ₹${this.state.storedMinRecharge}`,
                                                                            bgColor: "alert alert-danger alert-dismissible"
                                                                        });
                                                                    }
                                                                }}

                                                                className="btn mt-1  btn-success btn-block btn-sm ml-auto text-center ">  Recharge </button>
                                                            <img alt={'payment'} className='img-fluid m-auto pt-2' src={payment} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 text-right">
                                                    </div>
                                                </div>
                                            </div>

                                            :
                                            <>
                                                <div className="filter-option mt-2">
                                                    <h6 className="card-subtitle text-muted">Recharge </h6>
                                                    <div className="row">
                                                        <div className="col-md-8">
                                                            <div className="input-group mb-2 mr-sm-2">
                                                                <div className="input-group-text"><FontAwesomeIcon icon={faWallet} /></div>
                                                                <input type="number" onChange={(event) => {
                                                                    var sum = parseFloat(event.target.value);
                                                                    var convFee = parseFloat(sum * 0.04);
                                                                    var tc = sum + convFee;
                                                                    this.setState({ amount: tc });
                                                                    this.setState({ originalAmount: event.target.value })
                                                                    this.setState({ convenienceFee: convFee });
                                                                }
                                                                } 
                                                                // placeholder={`Minimum recharge amount should be ${this.state.storedMinRecharge} ${this.state.UserCountryCurrency}`}
                                                                 placeholder="Please enter the recharge amount"
                                                                 className="form-control"
                                                                 />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">

                                                            <div className="text-muted">
                                                                Convenience Fee : {this.state.convenienceFee}
                                                            </div>
                                                            Total Amount : <strong>
                                                                {
                                                                    this.state.amount || 0
                                                                }
                                                            </strong> {this.state.UserCountryCurrency}

                                                        </div>
                                                    </div>

                                                    <hr />

                                                    {/* {this.state.showPayPal ?

                                                        <div className='row mt-5 justify-content-center'>
                                                            <div className="input-group col-md-4 text-center  mb-2 mr-sm-2">
                                                                <button onClick={() => {
                                                                    if (this.state.amount >= 100) {
                                                                        this.setState({ showPayPal: false });
                                                                    } else {

                                                                        this.setState({ successMessage: true, errorMessage: 'Amount should be minimum 100 EUR', bgColor: "alert alert-danger alert-dismissible" });
                                                                    }

                                                                }} className="btn mt-1  btn-success btn-block btn-sm ml-auto text-center ">  Recharge </button>
                                                                <img alt={'payment'} className='img-fluid m-auto pt-2' src={payment} />

                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="paythroughpaypal">

                                                            <Paypal originalAmount={this.state.originalAmount} amount={this.state.amount} />

                                                        </div>
                                                    } */}
                                                    <div className='row mt-5 justify-content-center'>
                                                        <div className="input-group col-md-4 text-center mb-2 mr-sm-2">
                                                            <button
                                                                disabled={this.state.isStripeProcessing}
                                                                onClick={() => {
                                                                    if (this.state.originalAmount >= this.state.storedMinRecharge) {
                                                                        this.MakePaymentStripe(); // call Stripe API and redirect
                                                                    } else {
                                                                        this.setState({
                                                                            successMessage: true,
                                                                            // errorMessage: `Amount should be minimum 10 ${this.state.UserCountryCurrency}`,
                                                                             errorMessage: `Minimum recharge amount should be ${this.state.storedMinRecharge} ${this.state.UserCountryCurrency}`,
                                                                            bgColor: "alert alert-danger alert-dismissible"
                                                                        });
                                                                    }
                                                                }}
                                                                className="btn mt-1 btn-success btn-block btn-sm ml-auto text-center"
                                                            >
                                                                {this.state.isStripeProcessing ? 'Processing...' : 'Recharge with Stripe'}
                                                            </button>
                                                            <img alt={'payment'} className='img-fluid m-auto pt-2' src={payment} />
                                                        </div>
                                                    </div>

                                                </div>

                                            </>
                                        }
                                    </div>


                                </div>
                            </div>
                        </div>
                    </main>
                    <DashboardFooter />
                </div>

            </div>
        );
    }
}

export default TransactionPayment;